// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f18c2c1","239":"5214f9ca","453":"14a0b515","455":"f0ad3c48"}[chunkId] + ".chunk.js";
};